module.exports = __webpack_public_path__ + "static/media/icon_targeted_market.7a6708e9.svg";